module.exports = __webpack_public_path__ + "static/media/comment.62429ff9.svg";